module.exports = __webpack_public_path__ + "img/ClientLogo.b035eae9.jpg";